<template>

    <div  class="row justify-center full-height" >      
        <q-banner rounded class="bg-grey-3">
            <template v-slot:avatar>
                <img src="../assets/user.png" style="width: 100px; height: 100px">
            </template>
            <div class="row justify-center" >
                <div class=" col self-center ">
                    <div class="text-h4 ">
                        <u>
                            Account activation link has been sent to your email account
                        </u>
                    </div>
                </div>
            </div>
            <div class="row justify-center" >
                <div class="column justify-center">
                    <div class="text-h6">
                        Please click on the link that will be sent to your email account <b>{{StoreStateAOD.ContactInformation.EmailAddress}}</b> in a few minutes and continue the registration process.
                    </div>
                </div>
            </div> 
        </q-banner>

           <q-dialog v-model="requestUpdateAlert"  persistent transition-show="scale" transition-hide="scale">
            <q-card class="my-card" style="max-width:30vw">
            <q-card-section  class="bg-warning text-white text-body1">
                    Hi {{StoreStateAOD.PersonalInformation.FullName}},
            </q-card-section>
                <q-form   class="q-gutter-md" @submit="onSubmit">
                    <q-card-section>
                        <UpdateRequest/>  
                    </q-card-section>
    
            <q-card-actions align="right" >
                <q-btn label="Update" color="primary" text-color="white" type="submit" />
            </q-card-actions>
            </q-form>
            </q-card>
        </q-dialog>
    </div>
</template>
 
<script>
import { mapActions } from 'vuex';
import UpdateRequest from '@/components/UpdateRequest.vue'
import store from '../store'
export default {
    name : 'MessageHolder',
    components : {
        UpdateRequest
    },
    data() {
        return {
            StoreStateT : store.state.Transactions,
            StoreStateAOD : store.state.AOD, 
            StoreStateLookup : store.state.Lookup,
            StoreStateAD : store.state.AD,
            StoreStateFATCA : store.state.FATCA,
            StoreStateED : store.state.ED,
            StoreStateLogin: store.state.Login,
            requestUpdateAlert:false
        }
    },
    computed: {},
    mounted(){
        if((this.StoreStateAOD.ContactInformation.MobileNo == '') || (this.StoreStateAOD.ContactInformation.EmailAddress == '')){
                this.requestUpdateAlert = true;
               
            }else{ 
                 this.TriggerAccountCreation({
                 ApplicationId :this.StoreStateAOD.PersonalInformation.NRIC,
                firstTimeLoginInfo : this.StoreStateLogin.TransactionData
            });
        }
      
    },
    methods: {
        ...mapActions([
            "TriggerAccountCreation",            
            "CIFAccountInformationUpdate"
        ]), 
         onSubmit(){
            this.$q.loading.show({
                spinnerSize: 50
            }), 
            this.CIFAccountInformationUpdate()
            .then(res => {
                if(res == true){

                    this.requestUpdateAlert = false;
                    this.TriggerAccountCreation({
                        ApplicationId :this.StoreStateAOD.PersonalInformation.NRIC,
                        firstTimeLoginInfo : this.StoreStateLogin.TransactionData
                    });
                    this.$q.loading.hide()
                }else{
                this.$q.dialog({
                    title: 'Error',
                    message: 'Sorry, unable to update your info. Please contact our Customer Support to assist you on this'
                })
                this.$q.loading.hide()
                }

            })
        }

    }
}
</script>
